import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

function NavigationDesktopLink(props) {
  const { to, title } = props;

  return (
    <NavLink
      to={to}
      end
      className="border-b-2 border-b-transparent p-2 font-medium text-black text-sm outline-solid outline-white/0 outline-offset-0 hover:border-b-rcprimary-400 hover:bg-rcprimary-400/0 hover:text-rcprimary-400"
    >
      {title}
    </NavLink>
  );
}

NavigationDesktopLink.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default NavigationDesktopLink;
